enum SummaryDataItems {
  DISCOUNT = 'Savings Applied',
  LOCATION = 'Location',
  POINTS_EARNED = 'Points Earned',
  ID = 'Transaction ID',
}

export { SummaryDataItems };
